import React from 'react';

export default function Dialog(props) {
    return (
        <img src={props.image} className={"img--bg-full over"}/>
    )
}